export default {
domainInvalid: {
  siteUnavailableTitle: "سائٹ دستیاب نہیں",
  siteUnavailableDesc: "یہ سائٹ اس وقت دستیاب نہیں ہے۔",
  contactAdmin: "براہ کرم ایڈمنسٹریٹر سے رابطہ کریں۔",
  serverErrorTitle: "سروس دستیاب نہیں",
  serverErrorDesc: "سرور سے رابطہ نہیں ہو سکا، براہ کرم بعد میں دوبارہ کوشش کریں۔",
  serverErrorTip: "سرور بحال ہوتے ہی خودکار طور پر دوبارہ رابطہ ہو جائے گا۔",
  notAuthorizedTitle: "ڈومین مجاز نہیں",
  notAuthorizedDesc: "موجودہ ڈومین کو اس سروس تک رسائی کی اجازت نہیں ہے۔",
  checking: "جانچ ہو رہی ہے...",
  retry: "دوبارہ کوشش کریں",
  reload: "دوبارہ لوڈ کریں",
  reloading: "دوبارہ لوڈ ہو رہا ہے...",
  checkingDomain: "ڈومین کی جانچ ہو رہی ہے...",
  authorizedRedirecting: "ڈومین مجاز ہے، ری ڈائریکٹ ہو رہا ہے...",
  stillNotAuthorized: "ڈومین اب بھی مجاز نہیں ہے",
  reconnecting: "دوبارہ رابطہ ہو رہا ہے..."
}
};
